import instance from './requst'
export function getSTStoken() {
    return instance.get('/v1/token/sts_credential')
}
// export function postUpload(data) {
//     return instance.post('/v2/upload', data, {
//         headers: {
//             "Content-Type": "multipart/form-data"
//         }
//     })
// }
export function PostRequierments(data){
    return instance.post('/v1/requirements/',data)
}
export function PutRequierments(data,id){
    return instance.put(`/v1/requirements/${id}`,data)
}
export function GetRequierments(data){
    let url = '/v1/requirements/'
    
    // 构建query参数
    const queryParams = []
    
    if (data && data.page_size) {
        queryParams.push(`page_size=${data.page_size}`)
    }
    
    if (data && data.cursor) {
        queryParams.push(`cursor=${data.cursor}`)
    }
    
    if (data && data.filter_tags) {
        queryParams.push(`filter_tags=["${data.filter_tags}"]`)
    }
    
    if (data && data.filter_status) {
        queryParams.push(`filter_status=${data.filter_status}`)
    }
    
    // 如果有query参数，拼接到url中
    if (queryParams.length > 0) {
        url += '?' + queryParams.join('&')
    }
 
    return instance.get(url)
}
export function PatchRequierments(data){
    return instance.patch('/v1/requirements/status',data)
}
export function DelRequierments(data){
    let url = '/v1/requirements/'
   const list= data.map(item=>{
        return 'ids='+item
    })
    if (list.length > 0) {
        url += '?' + list.join('&')
    }
    return instance.delete(url)
}
export function DelOneRequierments(data){
    return instance.delete(`/v1/requirements/${
        data.id
    }`)
}
export function SearchRequierments(data){
    return instance.post(`/v1/requirements/search`,data)
}
/*
* 允许已授权的用户通过此接口搜索需求集
* */
export function SearchRequiermentsSet(data){
    return instance.get(`/v1/requirements/${data}`)
}